import { GET_PERMISSION } from "./permissionType"

 const getPermission = data => {
  return {
    type: GET_PERMISSION,
    data : data
  }
}
export default getPermission
